import axios from "axios";
import { ApiConfig, API_KEY } from "../config/api.config";

export class DriverService {

    static async registerDriver(data) {
        const request = await axios.post(ApiConfig.registerDriver, data, {
            headers: {
                Authorization: `apikey ${API_KEY}`
            }
        });
        return request.data.status === 200 ? Promise.resolve(request.data) : Promise.reject(request.data);
    }
}